// extracted by mini-css-extract-plugin
export var originalPrice = "_vl-0";